<template lang="html">
	<transition name="toast" @before-enter="beforeEnter" @enter="enter" @leave="leave">
		<div v-if="active" ref="toast" :style="stylex" class="ms-component ms-toastfications"
			:class="[`ms-toast-${position}`, { 'activetoast': active }, `ms-toast-${type}`]">
			<div class="ms-content-toast flex items-center justify-between h-full">
				<div class="flex items-center">
					<div class="mi-new-v2 mi-20" :class="`mi-icon-v2-toast-${type}`"></div>
					<div class="ms-mgl-8px" v-show="text" :class="`ms-text-${type}`" v-html="text"></div>
				</div>
				<div class="flex items-center">
					<div class="mi-new-v2 mi-16 mi-icon-v2-close-white-16" @click="clicktoast"></div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	data: () => ({
		type: 'success',
		time: 3000,
		position: 'bottom-right',
		active: true,
		text: null,
		fullWidth: false,
		cords: {
			top: null,
			left: null,
			right: null,
			bottom: null,
		},
		widthx: 0,
		fixed: false,
		mousedowntoast: false,
	}),
	computed: {
		fillingStyle() {
			return {
				left: this.cords.left ? '-100px' : null,
				right: this.cords.right ? '-100px' : null,
				background: this.color,
				height: `${this.widthx * 2}px`,
				width: `${this.widthx * 2}px`,
			};
		},
		stylex() {
			return {
				...this.cords,
				color: this.colorText,
				width: this.fullWidth ? `calc(100% - 14px)` : ``,
				maxWidth: 'none',
				minWidth: this.fullWidth ? 'none' : `300px`,
				border: 'none',
			};
		},
	},
	created() {
		setTimeout(() => {
			this.movertoasts();
		}, 0);
		this.changeCords();
	},
	watch: {
		type: {
			immediate: true,
			handler(newVal, oldVal) {
				const me = this;
				if (
					!newVal ||
					!(
						newVal == 'success' ||
						newVal == 'error' ||
						newVal == 'warning' ||
						newVal == 'process'
					)
				) {
					me.type = 'warning';
				}
			},
		},
	},
	mounted() {
		setTimeout(() => {
			this.widthx = this.$refs.toast.clientWidth;
		}, 0);

		if (!this.fixed) {
			setTimeout(() => {
				this.closetoast();
			}, this.time);
		}
	},
	methods: {
		clicktoast() {
			this.active = false;
			this.click ? this.click() : null;
		},
		beforeEnter(el) {
			el.style.opacity = 0;
		},
		enter(el, done) {
			el.style.opacity = 1;
			done();
		},
		leave(el, done) {
			el.style.opacity = 0;
			let transformx = el.style.transform;
			if (this.cords.left == '50%' || this.fullWidth) {
				transformx += ` translateY(${this.cords.top ? '-' : ''}100%)`;
			} else {
				transformx += ` translateX(${this.cords.left ? '-' : ''}100%)`;
			}
			el.style.transform = transformx;
			setTimeout(() => {
				done();
				this.movertoasts();
			}, 150);
		},
		closetoast() {
			this.active = false;
		},
		changeCords() {
			let positions = this.position.split('-');
			let search = (text) => {
				return positions.indexOf(text) != -1;
			};
			if (search('top')) {
				this.cords.top = '0px';
			}
			if (search('bottom')) {
				this.cords.bottom = '0px';
			}
			if (search('right')) {
				this.cords.right = '0px';
			}
			if (search('left')) {
				this.cords.left = '0px';
			}

			if (search('center')) {
				this.cords.left = '50%';
			}
		},
		movertoasts() {
			let toastsx = document.querySelectorAll('.ms-toast-' + this.position);
			for (let i = 0; i < toastsx.length; i++) {
				let hx = 10;
				for (let i2 = 0; i2 < i; i2++) {
					hx += toastsx[i2].clientHeight + 6;
				}
				if (this.position.search('center') == -1) {
					if (this.position.search('top') != -1) {
						toastsx[i].style.transform = `translatey(${hx}px)`;
					} else if (this.position.search('bottom') != -1) {
						toastsx[i].style.transform = `translatey(-${hx}px)`;
					}
				}
				if (
					this.position.search('top') != -1 &&
					this.position.search('center') != -1
				) {
					toastsx[i].style.transform = `translate(-50%, ${hx}px)`;
					toastsx[i].style.zIndex = 10000 - i;
				}
				if (
					this.position.search('bottom') != -1 &&
					this.position.search('center') != -1
				) {
					toastsx[i].style.transform = `translate(-50%,-${hx}px)`;
					toastsx[i].style.zIndex = 10000 - i;
				}
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/ms-Toast.scss';
}

@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/ms-Toast.scss';
}
</style>